/**
 * Speculation Rules - Prerender URLs on link hover
 */
document.addEventListener('DOMContentLoaded', function () {
  var links = document.querySelectorAll('a');
  
  links.forEach(function(link) {
    link.addEventListener('mouseover', function() {
      var url = link.href;
      var speculationRules = document.getElementById('speculationrules');
      
      if (!speculationRules) return;
      
      try {
        var rules = JSON.parse(speculationRules.textContent);
        
        if (!rules.prerender[0].urls.includes(url)) {
          rules.prerender[0].urls.push(url);
          speculationRules.textContent = JSON.stringify(rules);
        }
      } catch (e) {
        // Silently fail if parsing fails
      }
    });
  });
});
